const routes = {
  home: "/",
  signIn: "/sign-in",
  signInRole: "/sign-in/:role",
  signUp: "/sign-up",
  signUpVendor: "/sign-up/vendor",
  signUpAgency: "/sign-up/agency",
  signUpAgencyRnt: "/sign-up/agency/rnt",
  signUpAgencyData: "/sign-up/agency/data",
  signUpAgencyDocuments: "/sign-up/agency/documents",
  signUpAgencyPending: "/sign-up/agency/pending",
  signUpAgencySuccess: "/sign-up/agency/success",
  tickets: "/tickets",
  quotes: "/quotes",
  reports: "/reports",
  users: "/users",

  agency: "/agency",
  agencyDashboard: "/agency/dashboard",
  agencyExperienceCreation: "/agency/experience-creation",
  agencyExperienceCreationId: "/agency/experience-creation/:id",
  agencyExperienceCreationDetails: "/agency/experience-creation/:id/details",
  agencyExperienceCreationTransportSelection:
    "/agency/experience-creation/:id/transport-selection",
  agencyExperienceCreationPurchaseSummary:
    "/agency/experience-creation/:id/purchase-summary",
  agencyPaymentManagement: "/agency/payment-management",
  agencyPaymentManagementPricing: "/agency/payment-management/:id/pricing",
  agencyPaymentManagementInstallments:
    "/agency/payment-management/:id/installments",
  agencyPaymentManagementServices: "/agency/payment-management/:id/services",
  agencyPaymentManagementServicesService:
    "/agency/payment-management/:id/services/:service",
  agencyPaymentManagementPassengersInstallments:
    "/agency/payment-management/:id/passengers-installments",
  agencyTripsAndPassengers: "/agency/trips-and-passengers",
  agencyProfile: "/agency/profile",
  agencyProfileBalance: "/agency/profile/balance",
  agencyProfileDocuments: "/agency/profile/documents",
  agencyQuotations: "/agency/quotations",

  quotations: "/my-quotations",
  trips: "/my-trips",
  admin: "/admin",
  tour: "/tour/:id",
  tourSeatSelection: "/tour/:id/seat-selection",
  tourPurchaseSummary: "/tour/:id/purchase-summary",

  profile: "/profile",
  profileBalance: "/profile/balance",

  paymentResult: "/payment/result",

  experienceCreation: "/experience-creation",
  experienceCreationId: "/experience-creation/:id",
  experienceCreationDetails: "/experience-creation/:id/details",
  experienceCreationTransportSelection:
    "/experience-creation/:id/transport-selection",
  experienceCreationPurchaseSummary:
    "/experience-creation/:id/purchase-summary",
  experienceCreationComplements: "/experience-creation/:id/complements",

  tripsInstallments: "/trips/:id/installments",
};

export default routes;
